<app-landing-pages [dataId]="'about-data'"></app-landing-pages>